module.exports = __webpack_public_path__ + "media/images/social-share-button/twitter-7b6fb9bbc8e085423326545ba00dbbef.svg";